// extracted by mini-css-extract-plugin
export default {"popupHeader":"ModalHeader_popupHeader__VqhfN","title":"ModalHeader_title__sabvq","iconContainer":"ModalHeader_iconContainer__kTtdp","exitIcon":"ModalHeader_exitIcon__O57Ae"};